<template>
	<div class="text-center">
		<v-dialog
			v-model="show"
			width="600"
			@input="(v) => v || closeModal()"
			content-class="add-question-modal overflow-x-hidden"
			@click:outside="closeModal"
		>
			<v-card class="add-question-modal__card">
				<div class="add-question-modal__title">Ask a Question</div>
				<SessionQuestionForm
					:profile="profile"
					:qaIsAutocomplete="qaIsAutocomplete"
					:isQuestionsPage="isQuestionsPage"
					@updateList="updateList"
					v-on:closeModal="closeModal"
				/>
				<button type="button" class="add-question-modal__button-close" @click="closeModal">
					<Icon type="close" :size="24" color="var(--button-icon-tint)" />
				</button>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import SessionQuestionForm from '@/components/Forms/SessionQuestionForm.vue'
export default {
	components: {
		SessionQuestionForm,
	},
	props: {
		profile: {
			type: Object,
			default: () => ({}),
		},
		show: {
			type: Boolean,
			default: false,
		},
		qaIsAutocomplete: {
			type: Boolean,
			default: false,
		},
		isQuestionsPage: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		updateList() {
			this.$emit('updateList')
		},
		closeModal() {
			this.$emit('closeModal')
		},
	},
}
</script>

<style lang="scss">
.add-question-modal {
	border-radius: 10px;
	background-color: #fff;
	font-family: 'Inter', sans-serif;

	&__card {
		position: relative;
		padding: 24px;
	}

	&__title {
		color: #4a4a4a;
		font-size: 24px;
		font-weight: 700;
		line-height: 100%;
		letter-spacing: 0;
		margin-bottom: 20px;
	}

	&__label {
		font-size: 14px;
		font-weight: 700;
		line-height: 17.07px;
		color: var(--button-main-background-color);
		padding-bottom: 4.5px;
		border-bottom: 2px solid var(--button-main-background-color);

		&-wrapper {
			border-bottom: 1px solid #e2e2e2;
			padding-bottom: 3px;
			margin-bottom: 30px;
		}
	}

	&__button-close {
		position: absolute;
		top: 20px;
		right: 20px;
	}
}
</style>
